import { createServerFn } from '@tanstack/react-start';
import { getRequest } from '@tanstack/react-start/server';

import { requireStartAuthSession } from '../auth/require-start-auth-session.ts';
import { createServerFnObservabilityMiddleware } from '../utils/create-instrumented-server-fn.ts';

export const getNewPortfolioPageData = createServerFn({ method: 'GET' })
	.middleware([
		createServerFnObservabilityMiddleware({
			dependencies: ['auth.session'],
			relatesTo: 'portfolio.new-page',
		}),
	])
	.handler(async () => {
		await requireStartAuthSession({ request: getRequest() });

		return {};
	});
